import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ProgressBar from '../../components/ProgressBar/ProgressBar';

const ProgressLoaders = () => (
  <Row className="styles-section" id="progress-loaders">
    <Col xs={12}>
      <h3>Progress &amp; Loaders</h3>
    </Col>
    <Col xs={12} sm={6}>
      <div className="my-2">
        <ProgressBar size="small" now={0} />
      </div>
      <div className="my-2">
        <ProgressBar size="small" now={50} />
      </div>
      <div className="my-2">
        <ProgressBar size="small" now={100} />
      </div>
    </Col>
    <Col xs={12} sm={6}>
      <div className="my-2">
        <ProgressBar now={0} />
      </div>
      <div className="my-2">
        <ProgressBar now={50} />
      </div>
      <div className="my-2">
        <ProgressBar now={100} />
      </div>
    </Col>

  </Row >
);

export default ProgressLoaders;